import { use3DAnimation } from "../hooks/use3DAnimation";

const TeamSection = () => {
  const teamAnimation = use3DAnimation({ maxRotation: 8, scale: 1.02 });

  const teamMembers = [
    {
      id: 1,
      name: "Product Engineers",
      role: "Engineering Team",
      bio: "Cross-functional engineers building scalable products with clean architecture and performance-first delivery.",
      icon: "🧩",
      skills: ["TypeScript", "Next.js", "API Design", "Cloud", "Testing"]
    },
    {
      id: 2,
      name: "Expert Developers",
      role: "Development Team",
      bio: "Skilled developers specializing in frontend, backend, and full-stack development with modern technologies",
      icon: "👨‍💼",
      skills: ["Frontend", "Backend", "Database", "APIs"]
    },
    {
      id: 3,
      name: "UI/UX Designers",
      role: "Design Team",
      bio: "Creative designers focused on delivering exceptional user experiences and visual design excellence",
      icon: "🎨",
      skills: ["UI Design", "UX Research", "Figma", "Prototyping"]
    },
    {
      id: 4,
      name: "QA Engineers",
      role: "Quality Assurance Team",
      bio: "Testing specialists ensuring code quality, reliability, and performance across all deliverables",
      icon: "✅",
      skills: ["Testing", "QA Automation", "Performance", "Security"]
    }
  ];

  return (
    <section id="founder" className="py-16 space-y-8">
      <div className="text-center space-y-3">
        <p className="home-tagline">Meet the team</p>
        <h2 className="text-4xl font-bold text-white">Our Expert Team</h2>
        <p className="text-white/70 max-w-2xl mx-auto">
          A dedicated team of experienced professionals committed to delivering excellence and transforming your vision into reality
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
        {teamMembers.map((member) => (
          <div
            key={member.id}
            {...teamAnimation}
            className="card glass-panel rounded-2xl border border-white/30 bg-white/10 backdrop-blur-lg p-6 hover:shadow-2xl transition-all duration-500 group relative overflow-hidden text-center"
          >
            <div className="absolute inset-0 pointer-events-none bg-linear-to-br from-amber-500/0 to-orange-600/0 group-hover:from-amber-500/10 group-hover:to-orange-600/10 transition-all duration-500"></div>
            <div className="relative z-10">
              <div className="text-6xl mb-3 transform group-hover:scale-110 group-hover:-rotate-12 transition-all duration-500 inline-block">
                {member.icon}
              </div>
              <h3 className="text-xl font-bold text-white">{member.name}</h3>
              <p className="text-amber-400 text-sm font-semibold mt-1">{member.role}</p>
              <p className="text-white/70 text-sm mt-3">{member.bio}</p>
              <div className="flex flex-wrap gap-2 justify-center mt-4">
                {member.skills.map((skill, idx) => (
                  <span key={idx} className="text-xs bg-amber-500/20 text-amber-300 px-2 py-1 rounded-full">
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="text-center mt-8 p-6 rounded-2xl border border-white/30 bg-white/10 backdrop-blur-lg">
        <h3 className="text-xl font-bold text-white mb-2">🚀 A Startup with Big Ambitions</h3>
        <p className="text-white/80">
          ZS NEXATECH is a young and energetic startup bringing fresh perspectives and cutting-edge technology to software development. Founder-led delivery ensures clear direction, faster decisions, and a deep commitment to building solutions that drive real business impact.
        </p>
      </div>
    </section>
  );
};

export default TeamSection;
